import React from 'react'
import Skeleton from 'react-loading-skeleton'

const SkeletonFriendsHome = () => {
  return (
    <ul className="rightbarFriendsList">
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
        <li className="rightbarFriend">
            <div className="rightbarProfileImgContainer">
                <Skeleton circle className="rightbarProfileImg" />
            </div>
            <div className='w-50'>
                <Skeleton className="rightbarUsername" />
            </div>
        </li>
    </ul>
  ) 
}

export default SkeletonFriendsHome